import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Ai2Layout } from '../../layout/Ai2Layout';
import { SettingsLeftNavbar } from '../../components/Navbars';
import { SettingsLeftNavbarTabs } from '../../components/Navbars/types';
import { Preferences } from './Preferences';
import { SystemSettings } from './SystemSettings';
import { MedicationProfileSettings } from './MedicationProfileSettings';
import { useGlobalLoading } from '../../../context/LoadingContext';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState(SettingsLeftNavbarTabs.PREFERENCE);
  return (
    <Ai2Layout>
      <div className="ui">
        <div>
          <SettingsLeftNavbar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className="flexVert offsetNavbar offsetNavbarLeft">
            {activeTab === SettingsLeftNavbarTabs.PREFERENCE ? (
              <Preferences />
            ) : null}
            {activeTab === SettingsLeftNavbarTabs.SYSTEM_SETTINGS ? (
              <SystemSettings />
            ) : null}
            {activeTab ===
            SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS ? (
              <MedicationProfileSettings />
            ) : null}
            {activeTab === SettingsLeftNavbarTabs.NO_ACCESS ? (
              <span>There are no preferences/settings available for you</span>
            ) : null}
          </div>
        </div>
      </div>
    </Ai2Layout>
  );
};
export { SettingsPage };
